"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Upload = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_dropzone_1 = require("react-dropzone");
var uploadFile_1 = require("./uploadFile");
var uuid_1 = require("../_util/uuid");
var inject_value_1 = require("../_util/inject-value");
var is_callable_1 = require("../_util/is-callable");
var File_1 = require("./preset/File");
var Dragger_1 = require("./preset/Dragger");
var Image_1 = require("./preset/Image");
var UploadContext_1 = require("./UploadContext");
var noop_1 = require("../_util/noop");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
function isPromise(p) {
    return p && typeof p === "object" && typeof p.then === "function";
}
exports.Upload = forward_ref_with_statics_1.forwardRefWithStatics(function Upload(_a, ref) {
    var _b = _a.action, action = _b === void 0 ? "" : _b, accept = _a.accept, maxSize = _a.maxSize, _c = _a.multiple, multiple = _c === void 0 ? false : _c, _d = _a.directory, directory = _d === void 0 ? false : _d, headers = _a.headers, data = _a.data, method = _a.method, send = _a.send, _e = _a.name, name = _e === void 0 ? "file" : _e, withCredentials = _a.withCredentials, _f = _a.beforeUpload, beforeUpload = _f === void 0 ? function (_, __, isAccepted) { return isAccepted; } : _f, _g = _a.onStart, onStart = _g === void 0 ? noop_1.noop : _g, onProgress = _a.onProgress, onSuccess = _a.onSuccess, onError = _a.onError, children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["action", "accept", "maxSize", "multiple", "directory", "headers", "data", "method", "send", "name", "withCredentials", "beforeUpload", "onStart", "onProgress", "onSuccess", "onError", "children", "className"]);
    if (directory) {
        // eslint-disable-next-line no-param-reassign
        multiple = true;
    }
    var _h = tslib_1.__read(react_1.useState(false), 2), dragging = _h[0], setDragging = _h[1];
    var _j = react_dropzone_1.useDropzone({
        accept: accept,
        maxSize: maxSize,
        multiple: multiple,
        noClick: true,
        noKeyboard: true,
        onDrop: uploadFiles,
        onDragEnter: function () { return setDragging(true); },
        onDragLeave: function () { return setDragging(false); },
    }), getInputProps = _j.getInputProps, getRootProps = _j.getRootProps, open = _j.open;
    function uploadFiles(acceptedFiles, fileRejections) {
        var rejectedFiles = fileRejections.map(function (r) { return r.file; });
        var fileList = tslib_1.__spread(acceptedFiles, rejectedFiles);
        acceptedFiles.forEach(function (file) {
            file["id"] = uuid_1.uuid(); // eslint-disable-line dot-notation
            uploadFile(file, fileList, true);
        });
        fileRejections.forEach(function (_a) {
            var file = _a.file, errors = _a.errors;
            file["id"] = uuid_1.uuid(); // eslint-disable-line dot-notation
            uploadFile(file, fileList, false, errors);
        });
        setDragging(false);
    }
    function uploadFile(file, fileList, isAccepted, reasons) {
        if (reasons === void 0) { reasons = []; }
        var couldUpload = beforeUpload(file, fileList, isAccepted, reasons);
        if (isPromise(couldUpload)) {
            couldUpload.then(function () { return request(file); }).catch(function () { return null; });
        }
        else {
            if (!couldUpload) {
                return;
            }
            setTimeout(function () { return request(file); }, 0);
        }
    }
    function request(file) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uploadAction, error_1, xhr;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof action === "function")) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, action(file)];
                    case 2:
                        uploadAction = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        onError(error_1, { event: null, xhr: null, file: file });
                        return [2 /*return*/];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        uploadAction = action;
                        _a.label = 6;
                    case 6:
                        xhr = uploadFile_1.upload({
                            action: uploadAction,
                            filename: name,
                            file: file,
                            data: inject_value_1.injectValue(data)(file),
                            headers: inject_value_1.injectValue(headers)(file),
                            method: method,
                            send: send,
                            withCredentials: withCredentials,
                            onProgress: onProgress,
                            onSuccess: onSuccess,
                            onError: onError,
                        });
                        onStart(file, { xhr: xhr });
                        return [2 /*return*/];
                }
            });
        });
    }
    return (react_1.default.createElement(UploadContext_1.UploadContext.Provider, { value: { open: open, getDraggerProps: getRootProps, isDragging: dragging } },
        react_1.default.createElement("span", tslib_1.__assign({ ref: ref, className: className }, props),
            react_1.default.createElement("input", tslib_1.__assign({}, getInputProps(), {
                directory: directory ? "directory" : undefined,
                webkitdirectory: directory ? "webkitdirectory" : undefined,
            })),
            is_callable_1.isCallable(children) ? (children({
                open: open,
                getDraggerProps: getRootProps,
                isDragging: dragging,
            })) : (react_1.default.createElement("span", { onClick: open }, children)))));
}, {
    defaultLabelAlign: "middle",
    File: File_1.File,
    Dragger: Dragger_1.Dragger,
    Image: Image_1.Image,
});
exports.Upload.displayName = "Upload";
//# sourceMappingURL=Upload.js.map